import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlbums2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlbums2"><Path d="M18.5 3.5H5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 7.5H4.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 11.5H20.5L18.5 20.5H5.5L3.5 11.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlbums2;
